import Vue from 'vue';
import VueI18n from 'vue-i18n';
import MessageEn from './en';
import MessageKr from './kr';

Vue.use(VueI18n);

export default new VueI18n({
  locale: 'kr',
  messages: {
    kr: MessageKr,
    en: MessageEn
  }
});



// WEBPACK FOOTER //
// ./src/i18n/i18n.js